import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PermissionGroup } from './permission-models';
import { AutoTablePageableResponse } from '@muchencute/mrrs-types';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { CORE_CONFIG } from '../environment';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
    private authService: AuthService,
    @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/permission`;
  }

  getPermissions(roleName: string): Observable<PermissionGroup[]> {
    return this.httpClient.get<PermissionGroup[]>(`${this._baseURL}s`, {
      params: {
        roleName
      }
    });
  }



}
